/**
 * Slugify a string
 * @param string_ - The string to slugify
 * @returns A slugified string
 */
export function slugify(string_: string | undefined): string | undefined {
  if (!string_) return
  return string_
    .toString()
    .trim()
    .toLowerCase()
    .replaceAll(/[^\w ]+/g, '')
    .replaceAll(/ +/g, '-')
}

/**
 * Get the initials of a string
 * @param string_ - The string to get the initials of
 * @param length - The length of the initials
 * @returns The initials of the string
 */
export function getInitials(string_: string | undefined, length?: number) {
  if (!string_) return '?'
  const initials = string_.split(' ').reduce((accumulator, current) => {
    return accumulator + current[0]
  }, '')

  if (!length) return initials

  return initials.slice(0, length)
}

/**
 * Generate a hash from an id to use in stringToColor()
 * @see stringToColor
 * @param id - The id to hash
 * @returns - The hashed id
 */
export function hashId(id: number): string {
  let hash = id
  hash = (hash * 9301 + 49_297) % 233_280

  return hash.toString(36)
}

export function hashString(_string: string): string {
  let hash = 0
  if (_string.length === 0) return hash.toString(36)
  for (let index = 0; index < _string.length; index++) {
    const char = _string.charCodeAt(index)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }

  hash = (hash * 9301 + 49_297) % 233_280

  return hash.toString(36)
}

export function formatBytes(bytes: number, decimals: number = 2): string {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const index = Math.floor(Math.log(bytes) / Math.log(k))

  return (
    Number.parseFloat((bytes / Math.pow(k, index)).toFixed(dm)) +
    ' ' +
    sizes[index]
  )
}
/**
 * Strip HTML tags from a string
 * @param original - The string to strip HTML tags from
 * @returns The string without HTML tags
 */
export function stripHTML(original: string | undefined): string | undefined {
  return original ? original.replaceAll(/(<([^>]+)>)/gi, '') : undefined
}

/**
 * Truncate a string
 * @param string_ - The string to truncate
 * @param number_ - The number of characters to truncate to
 * @returns The truncated string
 */
export function truncateString(
  string_: string | undefined,
  number_: number,
): string | undefined {
  if (!string_) return
  if (string_.length <= number_) {
    return string_
  }
  return string_.slice(0, number_) + '...'
}
/**
 * Truncate a string with HTML tags
 * @param html - The HTML string to truncate
 * @param number_ - The number of characters to truncate to
 * @returns The truncated string
 */
export function truncateHTML(
  html: string | undefined,
  number_: number,
): string | undefined {
  if (!html) return
  return truncateString(stripHTML(html), number_)
}
